import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createQuote } from '../api/quotesApi';

// No client-side cache invalidation — the backend broadcasts UpdateQuoteTable
// to the tenant group after SaveChangesAsync, and useQuotes already invalidates
// ['quotes'] on that event (including for the creating tab). SignalR is the
// single sync mechanism; mirroring it here would just double-fetch.
export default function useCreateQuote() {
    return useMutation({
        mutationFn: createQuote,
        onSuccess: () => toast.success('Quote created'),
        onError: (err) => toast.error(err?.message ?? 'Failed to create quote'),
    });
}
